import React from "react";
import Button from "./Button";

const PAGE_SIZE_OPTIONS = [10, 20, 25, 50, 100];

const scrollAfterPagination = ({
  scrollTargetId,
  scrollToTop = true,
} = {}) => {
  if (scrollTargetId) {
    document.getElementById(scrollTargetId)?.scrollIntoView({
      block: "start",
      behavior: "auto",
    });
    return;
  }

  if (scrollToTop) {
    document.getElementById("main-content-scroll")?.scrollTo({
      top: 0,
      behavior: "auto",
    });
  }
};

const Pagination = ({
  page = 1,
  pageSize = 20,
  totalCount = 0,
  onPageChange,
  onPageSizeChange,
  isLoading = false,
  scrollTargetId,
  scrollToTop = true,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const start = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, totalCount);

  return (
    <div className="flex flex-col gap-3 border-t border-slate-100 px-6 py-4 text-sm text-slate-600 sm:flex-row sm:items-center sm:justify-between">
      <p>
        Showing {start}-{end} of {totalCount}
      </p>
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-3">
        {typeof onPageSizeChange === "function" && (
          <label className="flex items-center gap-2 text-sm text-slate-600">
            <span className="whitespace-nowrap">Rows per page</span>
            <select
              className="h-9 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-900 outline-none transition focus:border-slate-400"
              value={pageSize}
              onChange={(e) => {
                onPageSizeChange(Number(e.target.value));
                scrollAfterPagination({ scrollTargetId, scrollToTop });
              }}
              disabled={isLoading}
            >
              {PAGE_SIZE_OPTIONS.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
        )}
        <div className="flex items-center gap-3">
        <Button
          size="sm"
          variant="secondary"
          disabled={page <= 1 || isLoading}
          onClick={() => {
            onPageChange(page - 1);
            scrollAfterPagination({ scrollTargetId, scrollToTop });
          }}
        >
          Previous
        </Button>
          <span className="min-w-[88px] text-center font-medium text-slate-700">
            Page {page} of {totalPages}
          </span>
        <Button
          size="sm"
          variant="secondary"
          disabled={page >= totalPages || isLoading}
          onClick={() => {
            onPageChange(page + 1);
            scrollAfterPagination({ scrollTargetId, scrollToTop });
          }}
        >
          Next
        </Button>
        </div>
      </div>
    </div>
  );
};

export default Pagination;
